import get from 'lodash/get'

import { selectInfoById } from 'pages/vendor/modules/info'
import { isCateringVenue } from 'utils/cateringFlow'
import { resolveSlot, slotToIso } from 'utils/cateringSchedule'
import {
  DEFAULT_CATERING_ADDRESS,
  DEFAULT_CATERING_DATE_TIME,
  DEFAULT_CATERING_HEADCOUNT,
} from './catering-order-details'

export const selectCateringAddressByVenueId = (state, venueId) =>
  get(
    state,
    `cateringOrderDetails.${venueId}.address`,
    DEFAULT_CATERING_ADDRESS,
  )

export const selectCateringDateTimeByVenueId = (state, venueId) =>
  get(
    state,
    `cateringOrderDetails.${venueId}.dateTime`,
    DEFAULT_CATERING_DATE_TIME,
  )

export const selectCateringHeadcountByVenueId = (state, venueId) =>
  get(
    state,
    `cateringOrderDetails.${venueId}.headcount`,
    DEFAULT_CATERING_HEADCOUNT,
  )

export const selectCateringContactByVenueId = (state, venueId) =>
  get(state, `cateringOrderDetails.${venueId}.contact`, null)

/** See isCateringVenue: whitelabel, an isCatering venue, and the Flipt flag. */
export const selectIsCateringFlowByVenueId = (state, venueId) =>
  isCateringVenue(selectInfoById(state, venueId))

/**
 * The `catering` block for POST /orders/checkout and /orders/submit, or undefined
 * outside the catering flow. Same fields corporate-accounts-platform sends through
 * its api (`headcount`, `fulfillmentDate`); `withContact` adds the contact person,
 * which only the submit takes.
 */
export const selectCateringPayloadByVenueId = (
  state,
  venueId,
  { withContact = false } = {},
) => {
  if (!selectIsCateringFlowByVenueId(state, venueId)) return undefined

  const venue = selectInfoById(state, venueId)
  const timezone = get(venue, 'vendorProperty.timezone')
  const slot = resolveSlot(selectCateringDateTimeByVenueId(state, venueId), {
    timezone,
    openingHours: get(venue, 'openingHours'),
  })
  const contact = withContact && selectCateringContactByVenueId(state, venueId)

  return {
    headcount: selectCateringHeadcountByVenueId(state, venueId),
    ...(slot && { fulfillmentDate: slotToIso(slot, timezone) }),
    ...(contact && {
      contact: {
        name: [contact.firstName, contact.lastName].filter(Boolean).join(' '),
        phone: contact.mobile,
        email: contact.email,
      },
    }),
  }
}
